import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useDemo } from '@/contexts/DemoContext';
import { Loader2 } from 'lucide-react';

/**
 * DemoProtectedRoute - Allows access for authenticated users OR demo mode
 * 
 * This component wraps protected routes and allows access if:
 * 1. User is authenticated (real login)
 * 2. Demo mode is active
 * 
 * If neither condition is met, redirects to login.
 */

const DemoProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const { isDemoMode, loading: demoLoading } = useDemo();
  const location = useLocation();

  // Show loading while checking auth state
  if (authLoading || demoLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
      </div>
    );
  }

  // Allow access if authenticated OR in demo mode
  if (isAuthenticated || isDemoMode) {
    return children;
  }

  // Redirect to login if neither
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default DemoProtectedRoute;
